<template>
  <intro-template
    @start="next"
    button-label="Découvrir les règles relatives aux primes"
    duration="4">
    <template v-slot:module-title>
      Déclarer une prime, un jour férié ou le travail de nuit
    </template>
    <template v-slot:learnings-title>
      Dans ce module, vous allez apprendre...
    </template>
    <template v-slot:learnings>
      <p>Les règles qui encadrent les primes et majorations en vigueur dans votre société</p>
    </template>
    <template v-slot:rules>
      <div class="rule">
        <p class="label">
          Lisez
        </p>
        <p class="value">
          attentivement les règles relatives aux primes et majorations
        </p>
      </div>
      <div class="rule">
        <p class="label">
          Testez
        </p>
        <p class="value">
          vos connaissances
        </p>
      </div>
    </template>
  </intro-template>
</template>

<script>
import stepMixin from '@shared/mixins/stepMixin'

export default {
  name: 'Intro',
  mixins: [stepMixin]
}
</script>
